import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";

const SearchPage = () => {
  const [searchQuery, setSearchQuery] = useState("");
  const location = useLocation();

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    setSearchQuery(params.get("q") || "");
  }, [location]);

  return (
    <div>
      <h1>Search Results</h1>
      {searchQuery ? (
        <p>Showing results for: <strong>{searchQuery}</strong></p>
      ) : (
        <p>No search query provided.</p>
      )}
      {/* Here you can map over your search results based on the query */}
    </div>
  );
};

export default SearchPage;